var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e;
import { makeAutoObservable } from "mobx";
import { perRestaurant } from "../di";
import { DeliveryAddress, FreeDeliveryInfo, FulfillmentInstructions, FulfillmentInstructionsToken, } from "../ordering";
import { DialogStateManager } from "./DialogStateManager";
import { Money } from "../core";
import { inject } from "tsyringe";
import { translate, t } from "../I18n";
import { LocalizationProvider } from "../locale";
import { maxPriceForFreeDelivery } from "./MaxPriceForFreeDelivery";
let PFreeDeliveryWithoutAddressBottomSheet = class PFreeDeliveryWithoutAddressBottomSheet {
    constructor(domain, deliveryAddress, fulfillmentInstructions, dialogStateManager, localizationProvider) {
        this.domain = domain;
        this.deliveryAddress = deliveryAddress;
        this.fulfillmentInstructions = fulfillmentInstructions;
        this.dialogStateManager = dialogStateManager;
        this.localizationProvider = localizationProvider;
        makeAutoObservable(this);
    }
    get isDelivery() {
        if (this.fulfillmentInstructions.type === "Online") {
            return (this.fulfillmentInstructions.fulfillmentMethodType === "Delivery" ||
                this.fulfillmentInstructions.fulfillmentMethodType ===
                    "NoContactDelivery");
        }
        return false;
    }
    get isAddressFilledIn() {
        return !this.deliveryAddress.streetAddress.isEmpty;
    }
    get minDeliveryThreshold() {
        return this.domain.minPriceForFreeDelivery;
    }
    get shouldBeOpened() {
        var _a;
        return (this.dialogStateManager.state.freeDeliveryWithoutAddressBottomSheet ==
            true &&
            !this.isAddressFilledIn &&
            this.isDelivery &&
            this.minDeliveryThreshold !== null &&
            ((_a = this.minDeliveryThreshold) === null || _a === void 0 ? void 0 : _a.roundUp().asNumber) <=
                maxPriceForFreeDelivery(Skubacz.configuration.currency));
    }
    markAsClosed() {
        this.dialogStateManager.state.freeDeliveryWithoutAddressBottomSheet = false;
    }
    // Public only for analytics purposes
    get freeDeliveryPrice() {
        var _a, _b;
        return (_b = (_a = this.minDeliveryThreshold) === null || _a === void 0 ? void 0 : _a.roundUp()) !== null && _b !== void 0 ? _b : Money.zero();
    }
    get textMessage() {
        return translate(t.client.labels.free_delivery_fill_in_address, {
            amount: this.localizationProvider.formatPriceWithoutCents(this.freeDeliveryPrice),
        });
    }
};
PFreeDeliveryWithoutAddressBottomSheet = __decorate([
    perRestaurant(),
    __param(2, inject(FulfillmentInstructionsToken)),
    __metadata("design:paramtypes", [typeof (_a = typeof FreeDeliveryInfo !== "undefined" && FreeDeliveryInfo) === "function" ? _a : Object, typeof (_b = typeof DeliveryAddress !== "undefined" && DeliveryAddress) === "function" ? _b : Object, typeof (_c = typeof FulfillmentInstructions !== "undefined" && FulfillmentInstructions) === "function" ? _c : Object, typeof (_d = typeof DialogStateManager !== "undefined" && DialogStateManager) === "function" ? _d : Object, typeof (_e = typeof LocalizationProvider !== "undefined" && LocalizationProvider) === "function" ? _e : Object])
], PFreeDeliveryWithoutAddressBottomSheet);
export { PFreeDeliveryWithoutAddressBottomSheet };
